import { render, staticRenderFns } from "./tabRights.vue?vue&type=template&id=6f6ac9d0&scoped=true&"
import script from "./tabRights.vue?vue&type=script&lang=js&"
export * from "./tabRights.vue?vue&type=script&lang=js&"
import style0 from "./tabRights.vue?vue&type=style&index=0&id=6f6ac9d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ac9d0",
  null
  
)

export default component.exports